import { storeLabel } from '../config/rateShopConstants';
export const storeIdV2 = value =>
  String(value).startsWith('se-') ? String(value) : `se-${value}`;
export const normalizeStores = records =>
  [
    ...new Map(
      records
        .filter(s => s.storeId != null)
        .map(s => {
          const id = storeIdV2(s.storeId);
          return [
            id,
            {
              ...s,
              id,
              label: s.storeName || storeLabel(id),
              companyName: s.companyName?.trim() || 'Other'
            }
          ];
        })
    ).values()
  ].sort(
    (a, b) =>
      a.companyName.localeCompare(b.companyName) ||
      a.label.localeCompare(b.label)
  );
export const storeLabelForId = (id, stores = []) =>
  stores.find(s => s.id === id)?.label || storeLabel(id);
export const storeChoices = (stores, selected = []) => [
  ...stores.filter(s => s.active !== false || selected.includes(s.id)),
  ...selected
    .filter(id => id && !stores.some(s => s.id === id))
    .map(id => ({
      id,
      label: storeLabel(id),
      companyName: 'Other',
      marketplaceName: 'Saved store'
    }))
];

export const activeStoreCount = (stores, selected = []) => ({
  total: stores.filter(s => s.active !== false).length,
  selected: stores.filter(s => s.active !== false && selected.includes(s.id))
    .length
});
export const groupStores = (stores, selected = []) =>
  Object.entries(
    stores.reduce((groups, store) => {
      groups[store.companyName] = [...(groups[store.companyName] || []), store];
      return groups;
    }, {})
  ).sort(
    ([a, rowsA], [b, rowsB]) =>
      Number(rowsB.some(s => selected.includes(s.id))) -
        Number(rowsA.some(s => selected.includes(s.id))) || a.localeCompare(b)
  );
